import { useContext, useState } from "react";
import { Box, Button, Grid, Stack, Fade } from "@mui/material";
import { useLocation } from "react-router-dom";
// Project Imports
import "./studentdetail.scss";
import { StudentCard } from "./StudentCard";
import { AuthContext } from "../../../Context/AuthContext";
import { PageHeaderTitle } from "../../../Utils/Component";
import EmptyData from "../../../Components/Include/EmptyData/EmptyData";
import ClassCard from "./ClassCard/ClassCard";
import CreateIcon from "../../../Assets/create-icon.svg";
import LoadingPage from "../../../Utils/LoadingPage";
import AssignClassToStudentForm from "./AssignClassToStudentForm";
import useGetEnrollmentByStudent from "../../../Hooks/useGetEnrollmentByStudent";
// Feature Components
import Payment from "../../StudyClass/PaymentForStudent/PaymentForStudent";
import Homework from "../../StudyClass/HomeworkForStudent/HomeworkForStudent";
import TeachingTime from "../../StudyClass/TeachingTimeForStudent/TeachingTimeForStudent";

export const StudentDetail = () => {
  //
  const { t } = useContext(AuthContext);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const studentId = params.get("studentId");

  const [studentTab, setStudentTab] = useState("homework");
  //
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //
  const { studentEnrollmentData, refetch, loading } = useGetEnrollmentByStudent(
    {
      id: studentId,
      status: "all",
    },
  );

  // console.log("studentEnrollmentData::", studentEnrollmentData)

  const tabItems = [
    { value: "homework", label: t("thead_homework") },
    { value: "teaching-time", label: t("thead_teaching_time") },
    { value: "payment", label: t("thead_payment") },
    { value: "class", label: t("thead_class") },
    // { value: "studying", label: t("thead_studying") },
    // { value: "complete", label: t("thead_completed") },
    // { value: "dropout", label: t("thead_dropout") },
  ];

  const componentMap = {
    homework: Homework,
    "teaching-time": TeachingTime,
    payment: Payment,
  };

  const ActiveComponent = componentMap[studentTab];
  // Props passed to each tab component
  const tabPropsMap = {
    homework: { studentId },
    "teaching-time": { studentId },
    payment: { studentId },
  };

  const activeProps = tabPropsMap[studentTab] || {};
  //

  return (
    <Stack direction="column" spacing={2} className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo="/student"
        pageTitle={t("page_student")}
        detailTitle={t("page_student_details")}
      />

      <Box>
        <Grid container spacing={4}>
          <Grid item xs={12} md={12} lg={3} xl={3}>
            <StudentCard />
          </Grid>

          <Grid item xs={12} md={12} lg={9} xl={9}>
            <Stack spacing={2} sx={{ marginTop: "30px" }}>
              {/* Tab Header */}
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                className="tab-container"
                sx={{ position: "relative" }}
              >
                <Box
                  sx={{ position: "absolute", bottom: "-2px", width: "100%" }}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Stack direction="row">
                      {tabItems.map((tab) => (
                        <Button
                          key={tab.value}
                          className={
                            studentTab === tab.value
                              ? t("class-name-tab-item-active")
                              : t("class-name-tab-item")
                          }
                          onClick={() => setStudentTab(tab.value)}
                        >
                          {tab.label}
                        </Button>
                      ))}
                    </Stack>

                    {studentTab === "class" && (
                      <Button
                        onClick={handleOpen}
                        className="btn-create"
                        startIcon={
                          <img
                            src={CreateIcon}
                            alt="Create"
                            className="icon-add"
                          />
                        }
                      >
                        {t("create")}
                      </Button>
                    )}
                  </Stack>
                </Box>
              </Stack>

              {/* Tab Content */}
              <Fade in={true} timeout={400} key={studentTab}>
                <Box width="100%">
                  {ActiveComponent ? (
                    <ActiveComponent {...activeProps} />
                  ) : (
                    <Grid container spacing={2} sx={{ mt: 0.05 }}>
                      {loading ? (
                        <Grid item xs={12}>
                          <Stack
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                              height: 320,
                              width: "100%",
                              bgcolor: "white",
                              borderRadius: 1,
                            }}
                          >
                            <LoadingPage />
                          </Stack>
                        </Grid>
                      ) : studentEnrollmentData?.length === 0 ? (
                        <Grid item xs={12}>
                          <Stack
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                              height: 320,
                              width: "100%",
                              bgcolor: "white",
                              borderRadius: 1,
                            }}
                          >
                            <EmptyData />
                          </Stack>
                        </Grid>
                      ) : (
                        studentEnrollmentData?.map((data, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={4}
                            xl={3}
                            key={index}
                          >
                            <ClassCard data={data} setRefetch={refetch} />
                          </Grid>
                        ))
                      )}
                    </Grid>
                  )}
                </Box>
              </Fade>
            </Stack>
          </Grid>
        </Grid>
      </Box>

      {/* Modal */}
      {open && (
        <AssignClassToStudentForm
          open={open}
          setRefetch={refetch}
          studentId={studentId}
          handleClose={handleClose}
          dialogTitle="Create"
        />
      )}
    </Stack>
  );
};
